export const noSymptomKeywords = ["none", "no symptom", "no symptoms"];
